import React, { useState } from 'react';

import { selectCommandByNodeId, State } from '@store/index';
import { useSelector } from 'react-redux';
import { NodeSidebarHeader } from '@common/Node/NodeSidebar/NodeSidebarHeader';
import { NodeSidebarContainer } from '@common/Node/NodeSidebar/NodeSidebarContainer';
import { InboundMessageTabs } from './Tabs';
import { useStopwatch } from 'react-timer-hook';
import { WorkflowExecutionType } from '@common/Node/NodeSidebar/NodeExecutionHeader';
import { WorkflowRunMessage } from '@components/Modals/WorkflowRunMessage/WorkflowRunMessage';

interface Props {
  abortControllerRef: React.MutableRefObject<AbortController | null>;
}

export const InboundMessageSidebar: React.FC<Props> = ({ abortControllerRef }) => {
  const { seconds, minutes, start, pause, reset } = useStopwatch({ autoStart: false });

  const [tab, setTab] = useState('1');

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return <NodeSidebarContainer />;

  return (
    <NodeSidebarContainer>
      <NodeSidebarHeader
        command={command}
        workflowExecution={{
          tab,
          setTab,
          abortControllerRef,
          type: WorkflowExecutionType.InboundMessage,
          timer: {
            minutes,
            seconds,
            start,
            pause,
            reset,
          },
        }}
      />
      <InboundMessageTabs
        tab={tab}
        setTab={setTab}
        abortControllerRef={abortControllerRef}
        start={start}
        pause={pause}
        reset={reset}
      />
      <WorkflowRunMessage abortControllerRef={abortControllerRef} start={start} pause={pause} reset={reset} />
    </NodeSidebarContainer>
  );
};
